export default __webpack_public_path__ + "static/media/HindMadurai-Bold.ef56d9ca.ttf";